export default "//cdn.scentbird.com/assets/frontbird-site/images/desktop_4644e6.jpg";